import { Injectable, OnDestroy } from "@angular/core";
import { Subject, BehaviorSubject, fromEvent } from "rxjs";
import { takeUntil, debounceTime } from "rxjs/operators";
import { Router } from "@angular/router";

// Menu
export interface Menu {
  headTitle1?: string;
  headTitle2?: string;
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
}

@Injectable({
  providedIn: "root",
})
export class NavService implements OnDestroy {
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(
    window.innerWidth
  );

  // Search Box
  public search: boolean = false;

  // Language
  public language: boolean = false;

  // Mega Menu
  public megaMenu: boolean = false;
  public levelMenu: boolean = false;
  public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Full screen
  public fullScreen: boolean = false;

  constructor(private router: Router) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, "resize")
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }
  }

  ngOnDestroy() {
    // this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  MENUITEMS: Menu[] = [
    {
      headTitle1: "Dashboard",
    },
    {
      title: "Dashboard",
      icon: "home",
      type: "link",
      badgeType: "light-primary",
      active: true,
      path: "/dashboard/ecommerce",
    },

    {
      headTitle1: "User management",
    },
    {
      title: "Manage customers",
      icon: "user",
      type: "link",
      badgeType: "light-primary",

      path: "/features/users",
    },

    {
      title: "Manage categories",
      headTitle1: "Content managment",
    },
    {
      title: "Manage Brands",
      icon: "user",
      type: "link",
      badgeType: "light-primary",

      path: "/features/brands",
    },
    {
      title: "Manage categories",
      icon: "user",
      type: "link",
      badgeType: "light-primary",

      path: "/features/categories",
    },
    {
      title: "Manage attribute keys",
      icon: "user",
      type: "link",
      badgeType: "light-primary",

      path: "/features/attribute-keys",
    },
    {
      title: "Manage inventory",
      headTitle1: "Product and listing",
    },

    {
      title: "Manage products",
      icon: "user",
      type: "link",
      badgeType: "light-primary",

      path: "/features/products",
    },
    {
      title: "Manage inventory",
      headTitle1: "Orders",
    },
    {
      title: "Manage Orders",
      icon: "user",
      type: "sub",
      badgeType: "light-primary",
      badgeValue: "2",

      children: [
        {
          path: "/features/orders/purchases",
          title: "Purchases list",
          type: "link",
        },
        { path: "/features/orders/sales", title: "Sales list", type: "link" },
      ],
    },

    {
      title: "Manage Jeton Packs",
      headTitle1: "Jeton packs",
    },

    {
      title: "Manage Jeton Packs",
      icon: "user",
      type: "link",
      badgeType: "light-primary",
      active: true,
      path: "/features/jeton-packs",
    },
    {
      title: "Manage Pack Purchases",
      icon: "user",
      type: "link",
      badgeType: "light-primary",

      path: "/features/jeton-pack-purchases",
    },
    {
      title: "Manage Payments",
      headTitle1: "Financial",
    },

    {
      title: "Manage deposits",
      icon: "user",
      type: "link",
      badgeType: "light-primary",

      path: "/features/deposits",
    },
    {
      title: "Manage vendor incomes",
      icon: "user",
      type: "link",
      badgeType: "light-primary",

      path: "/features/vendor-incomes",
    },
    {
      title: "Manage payouts",
      icon: "user",
      type: "link",
      badgeType: "light-primary",

      path: "/features/payouts",
    },
    {
      headTitle1: "Platform settings",
    },
    {
      title: "Configuratons",
      icon: "wrench",
      type: "sub",
      badgeType: "light-primary",
      badgeValue: "5",

      children: [
        {
          path: "/features/configuration",
          title: "Platform configuration",
          type: "link",
        },
        { path: "/dashboard/default", title: "Mesurement unit", type: "link" },
        { path: "/features/languages", title: "Languages", type: "link" },
        { path: "/dashboard/ecommerce", title: "Currencies", type: "link" },
        { path: "/dashboard/online-course", title: "Countries", type: "link" },
      ],
    },
  ];

  // Array
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
